import React from 'react';

import { css, keyframes } from '@emotion/css';
import PokemonLogo from '../PokemonLogo/PokemonLogo';

const gradentShift = keyframes`
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`

export default function PokemonSplash() {
    return (
        <div className={css`
            background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
            background-size: 400% 400%;
            animation: ${gradentShift} 10s ease infinite;
            padding: 15px 0;
            min-height: 150px;
        `}>
            <PokemonLogo />
        </div>
    )
}
